"use client";
import useIsClient from "@/hooks/useIsClient";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import useShouldFire from "./useShouldFire";
export default function useTiktokPixel(
  pixel_id?: string | number,
  refresh?: boolean,
) {
  const pathname = usePathname();
  const client = useIsClient();
  const shouldFire = useShouldFire();
  useEffect(() => {
    if (!pixel_id || !client || !shouldFire) return;
    if (pathname) {
      let ReactPixel: any;
      import("tiktok-pixel")
        .then((module) => (ReactPixel = module.default))
        .then(() => {
          ReactPixel.init(pixel_id);
          ReactPixel.pageView();
        });
    }
  }, [pathname, client, pixel_id, refresh, shouldFire]);
  function trackEvent(event: any, data: any) {
    let ReactPixel: any;
    import("tiktok-pixel")
      .then((module) => (ReactPixel = module.default))
      .then(() => {
        ReactPixel.track(event, { ...data });
      });
  }

  return { trackEvent };
}
